import products from "db/products.json";
import productsConfiguration from "db/products_configurations.json";
import { replaceChar } from "utils/general";

// Nuovo layout tabelle - stile pulito come UI
const modernTableLayout = {
  hLineWidth: function (i, node) {
    return 1;
  },
  vLineWidth: function (i, node) {
    return 0; // Nessuna linea verticale
  },
  hLineColor: function (i, node) {
    return "#E7E7E7"; // Grigio chiaro
  },
  fillColor: function (rowIndex, node, columnIndex) {
    if (rowIndex === 0) return "#F8F9FA"; // Header grigio chiaro
    return rowIndex % 2 === 0 ? "#FFFFFF" : "#F8F9FA"; // Alternate
  },
  paddingLeft: function (i, node) {
    return 8;
  },
  paddingRight: function (i, node) {
    return 8;
  },
  paddingTop: function (i, node) {
    return 6;
  },
  paddingBottom: function (i, node) {
    return 6;
  },
};

// Mantengo i vecchi nomi per compatibilità ma tutti usano il nuovo stile
const blueTableLayout = modernTableLayout;
const whiteTableLayout = modernTableLayout;
const pinkTableLayout = modernTableLayout;

const splitAndShift = (string) => {
  return string.split(" ").slice(1).join(" ");
};

const formattedPdf = (
  catalogue,
  circles,
  product,
  type,
  filteredCouplings,
  printPage,
  image,
  formattedPlacca,
  logoImage
) => {
  const getConfigurationQuantity = (name) => {
    let quantity = 0;
    formattedPlacca.forEach((circle) => {
      const number = Object.keys(circle).filter((code) => code === name).length;
      quantity += number;
    });
    return quantity;
  };

  // TABELLE CONFIGURAZIONE

  const getConfigurationData = (circles, type) => {
    return circles
      .filter((circle) => !!circle && circle.type === type)
      .map((circle, i) => {
        if (type === "hydraulic") {
          return [
            { style: "cellStyle", text: `LINE ${i + 1}`, alignment: "left" },
            {
              style: "cellStyle",
              text: circle.setting?.body_size.label,
              alignment: "center",
            },
            {
              style: "cellStyle",
              text: `${circle.setting?.litre.value} l/min`,
              alignment: "center",
            },
            {
              style: "cellStyle",
              text: circle.setting?.thread.value,
              alignment: "center",
            },
            {
              style: "cellStyle",
              text: `${circle.setting?.port.value}"`,
              alignment: "center",
            },
          ];
        } else if (type === "electric") {
          return [
            {
              style: "cellStyle",
              text: `${
                circles.filter((value) => value?.type === type).length
              } Line${
                circles.filter((value) => value?.type === type).length > 1
                  ? "s"
                  : ""
              } `,
              alignment: "left",
            },
          ];
        }
        return null;
      });
  };

  const getConfigurationSection = (catalogue, circles) => {
    if (!catalogue) {
      if (circles.some((circle) => !!circle && circle.type === "electric")) {
        return [
          { text: "YOUR CONFIGURATION", style: "header" },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*", "*"],
              body: [
                [
                  {
                    text: "Hydraulic Lines",
                    style: "tableHeader",
                    alignment: "left",
                  },
                  {
                    text: "Body Size",
                    style: "tableHeader",
                    alignment: "center",
                  },
                  {
                    text: "Flow Rate",
                    style: "tableHeader",
                    alignment: "center",
                  },
                  { text: "Thread", style: "tableHeader", alignment: "center" },
                  { text: "Port", style: "tableHeader", alignment: "center" },
                ],
                ...getConfigurationData(circles, "hydraulic"),
              ],
            },
            layout: blueTableLayout,
          },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*"],
              body: [
                [
                  {
                    text: "Electric Lines",
                    style: "tableHeader",
                    alignment: "left",
                  },
                ],
                ...getConfigurationData(circles, "electric"),
              ],
            },
            layout: pinkTableLayout,
          },
        ];
      } else {
        return [
          { text: "YOUR CONFIGURATION", style: "header" },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*", "*"],
              body: [
                [
                  {
                    text: "Hydraulic Lines",
                    style: "tableHeader",
                    alignment: "left",
                  },
                  {
                    text: "Body Size",
                    style: "tableHeader",
                    alignment: "center",
                  },
                  {
                    text: "Flow Rate",
                    style: "tableHeader",
                    alignment: "center",
                  },
                  { text: "Thread", style: "tableHeader", alignment: "center" },
                  { text: "Port", style: "tableHeader", alignment: "center" },
                ],
                ...getConfigurationData(circles, "hydraulic"),
              ],
            },
            layout: blueTableLayout,
          },
        ];
      }
    } else return [];
  };

  // HEADER PDF (Nome + Logo)

  const getHeader = (logoImage) => {
    if (logoImage) {
      return [
        {
          margin: [0, 15, 0, 15],
          table: {
            widths: ["*", "auto"],
            body: [
              [
                {
                  text: product.name,
                  fontSize: 16,
                  bold: true,
                  color: "#E6007E",
                  alignment: "left",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  image: logoImage,
                  width: 100,
                  alignment: "right",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: "noBorders",
        },
      ];
    }
    // Se non c'è logo, mostra solo il nome
    return [
      {
        text: product.name,
        fontSize: 16,
        bold: true,
        color: "#E6007E",
        alignment: "left",
        margin: [0, 15, 0, 15],
      },
    ];
  };

  // WARNING COMPONENT

  const getWarning = () => {
    return [
      {
        margin: [0, 15, 0, 15],
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "Please address to Stucchi Technical Service for more information.",
                    fontSize: 10,
                    bold: true,
                    color: "#760042",
                    margin: [0, 0, 0, 6],
                  },
                  {
                    text: "The force applied to multicoupling coupled depends on the number of couplings under pressure at the same time, on their operating pressure and on their size. For a correct use of the multicoupling it is necessary to verify that the force is not higher than the maximum resistance of the multicoupling.",
                    fontSize: 9,
                    color: "#D9017A",
                  },
                ],
                margin: 10,
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          fillColor: () => "#FFD5ED",
          paddingLeft: () => 10,
          paddingRight: () => 10,
          paddingTop: () => 10,
          paddingBottom: () => 10,
        },
      },
    ];
  };

  // IMMAGINE PRODOTTO

  const getImage = (printPage, image) => {
    if (printPage) {
      return [
        {
          image,
          width: 300,
          margin: [100, 10, 0, 10],
        },
        {
          text: "The image is for illustrative purposes only, please refer to the drawings in the Stucchi catalog.",
          fontSize: 9,
          italics: true,
          color: "#666666",
          margin: [100, 5, 100, 10],
          alignment: "right",
        },
      ];
    } else {
      return [];
    }
  };

  // TABELLE PRODOTTI

  const getProductsSection = (
    product,
    type,
    filteredCouplings,
    catalogue,
    circles
  ) => {
    if (
      (type === "COMPLETE" || type === "FIX" || type === "MOBILE") &&
      !product.name.includes("EMPTY")
    ) {
      return [...getNotEmptyProductSection(product, type, filteredCouplings)];
    } else {
      return [
        ...getEmptyProductSection(
          product,
          type,
          filteredCouplings,
          catalogue,
          circles
        ),
      ];
    }
  };

  // TABELLE COMPONENTS INCLUDED

  const getIncludedProducts = (product, type, couplings, cap) => {
    const related = products
      .filter((prod) => {
        if (type !== "COMPLETE") {
          return (
            prod.picture === product.picture &&
            prod.name.includes("EMPTY") &&
            prod.name.includes(type === "FIX" ? "FIX" : "MOBILE")
          );
        } else {
          if (!product.name.includes("V0")) {
            return (
              prod.picture === product.picture &&
              prod.name.includes("EMPTY") &&
              !prod.name.includes("V0")
            );
          } else {
            return (
              prod.picture === product.picture && prod.name.includes("EMPTY")
            );
          }
        }
      })
      .map((component, i) => {
        return [
          { style: "cellStyle", text: component.code },
          { style: "cellStyle", text: "1" },
          { style: "cellStyle", text: component.name },
        ];
      });

    let couplingMRow = [];
    const couplingM = couplings.map((coup, i) => {
      const matched = productsConfiguration.find(
        ({ code }) => code === coup[0]
      );

      if (type === "COMPLETE" || type === "FIX") {
        return [
          { style: "cellStyle", text: matched?.mobile },
          { style: "cellStyle", text: coup[1] },
          { style: "cellStyle", text: `M ${coup[0]}` },
        ];
      } else return null;
    });
    if (!!couplingM && !!couplingM[0]) {
      couplingMRow = couplingM;
    }

    let couplingFRow = [];
    const couplingF = couplings.map((coup, i) => {
      const matched = productsConfiguration.find(
        ({ code }) => code === coup[0]
      );
      if (type === "COMPLETE" || type === "MOBILE") {
        return [
          { style: "cellStyle", text: matched?.fixed },
          { style: "cellStyle", text: coup[1] },
          { style: "cellStyle", text: `F ${coup[0]}` },
        ];
      } else return null;
    });
    if (!!couplingF && !!couplingF[0]) {
      couplingFRow = couplingF;
    }

    let capRow = [];
    if (product.cap) {
      capRow = [
        [
          { style: "cellStyle", text: product.cap.split(" ")[0] },
          { style: "cellStyle", text: "1" },
          {
            style: "cellStyle",
            text: product.cap.substring(product.cap.indexOf(" ") + 1),
          },
        ],
      ];
    }

    return [...related, ...couplingFRow, ...couplingMRow, ...capRow];
  };

  const getRelatedProducts = (product, type, couplings, cap) => {
    if (type === "COMPLETE") {
      return products
        .filter((prod) => {
          const mobileCode = replaceChar(product.code, "1", -3);
          const fixCode = replaceChar(product.code, "2", -3);

          return prod.code === mobileCode || prod.code === fixCode;
        })
        .map((component) => {
          return [
            { style: "cellStyle", text: component.code },
            { style: "cellStyle", text: "1" },
            { style: "cellStyle", text: component.name },
          ];
        });
    } else if (type === "MOBILE" || type === "FIX") {
      const relatedRows = products
        .filter(
          (prod) =>
            prod.picture === product.picture &&
            prod.name.includes("EMPTY") &&
            prod.name.includes(type !== "FIX" ? "FIX" : "MOBILE")
        )
        .map((component, i) => {
          return [
            { style: "cellStyle", text: component.code },
            { style: "cellStyle", text: "1" },
            { style: "cellStyle", text: component.name },
          ];
        });

      const couplingRows = couplings.map((coup, i) => {
        const matched = productsConfiguration.find(
          ({ code }) => code === coup[0]
        );
        if (type !== "MOBILE") {
          return [
            { style: "cellStyle", text: matched?.fixed },
            { style: "cellStyle", text: coup[1] },
            { style: "cellStyle", text: `F ${coup[0]}` },
          ];
        } else if (type !== "FIX") {
          return [
            { style: "cellStyle", text: matched?.mobile },
            { style: "cellStyle", text: coup[1] },
            { style: "cellStyle", text: `M ${coup[0]}` },
          ];
        }
        return null;
      });
      let capRow = [];
      if (product.cap && type !== "FIX") {
        capRow = [
          [
            { style: "cellStyle", text: product.cap.split(" ")[0] },
            { style: "cellStyle", text: "1" },
            {
              style: "cellStyle",
              text: product.cap.substring(product.cap.indexOf(" ") + 1),
            },
          ],
        ];
      }
      let parkingStation = [];
      if (product.parking_station && type !== "MOBILE") {
        parkingStation = [
          [
            { style: "cellStyle", text: product.parking_station.split(" ")[0] },
            { style: "cellStyle", text: "1" },
            {
              style: "cellStyle",
              text: product.parking_station.substring(
                product.parking_station.indexOf(" ") + 1
              ),
            },
          ],
        ];
      }
      return [...relatedRows, ...couplingRows, ...capRow, ...parkingStation];
    }
  };

  const getNotEmptyProductSection = (product, type, filteredCouplings) => {
    let tables = [
      { text: "SELECTED PRODUCT", style: "header" },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "*"],
          body: [
            [
              { text: "Code", style: "tableHeader", alignment: "left" },
              { text: "Name", style: "tableHeader", alignment: "left" },
              { text: "Description", style: "tableHeader", alignment: "left" },
            ],
            [
              {
                style: "cellStyle",
                text: product.code,
              },
              { style: "cellStyle", text: product.name },
              {
                style: "cellStyle",
                text: product.description,
              },
            ],
          ],
        },
        layout: whiteTableLayout,
      },
      {
        text: `Max operating resistance is ${product.max_resistance}`,
        style: "tableFooter",
      },
      { text: "COMPONENTS INCLUDED", style: "subHeader" },
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "*"],
          body: [
            [
              { text: "Code", style: "tableHeader", alignment: "left" },
              { text: "Quantity", style: "tableHeader", alignment: "left" },
              { text: "Description", style: "tableHeader", alignment: "left" },
            ],
            ...getIncludedProducts(product, type, filteredCouplings),
          ],
        },
        layout: blueTableLayout,
      },
      { text: "RELATED PRODUCTS ", style: "subHeader" },
      {
        style: "tableExample",
        table: {
          widths: ["auto", "auto", "*"],
          headerRows: 1,
          body: [
            [
              { text: "Code", style: "tableHeader", alignment: "left" },
              { text: "Quantity", style: "tableHeader", alignment: "left" },
              { text: "Description", style: "tableHeader", alignment: "left" },
            ],
            ...getRelatedProducts(product, type, filteredCouplings),
          ],
        },
        layout: blueTableLayout,
      },
    ];

    if (!!product.parking_station) {
      tables = [
        ...tables,
        { text: "AVAILABLE UPON REQUEST", style: "subHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["auto", "auto", "*"],
            headerRows: 1,
            body: [
              [
                { text: "Code", style: "tableHeader" },
                { text: "Quantity", style: "tableHeader" },
                { text: "Description", style: "tableHeader" },
              ],
              [
                {
                  style: "cellStyle",
                  text: product.parking_station.split(" ")[0],
                },
                { style: "cellStyle", text: "1" },
                {
                  style: "cellStyle",
                  text: product.parking_station.substring(
                    product.parking_station.indexOf(" ") + 1
                  ),
                },
              ],
            ],
          },
          layout: blueTableLayout,
        },
      ];
    }
    return tables;
  };

  // TABELLE PRODOTTI EMPTY

  const getEmptyCouple = (product) => {
    const code = product.name
      .split("MULTI")
      .join("")
      .split("COMPLETE")
      .join("")
      .split("FIX")
      .join("")
      .split("MOBILE")
      .join("")
      .split("EMPTY")
      .join("")
      .split("- CAP")
      .join("")
      .trim();

    const emptyCouple = products.filter(
      (prod) => prod.name.includes(code) && prod.name.includes("EMPTY")
    );

    return emptyCouple.map((component, i) => {
      return [
        {
          style: "cellStyle",
          text: component.code,
        },
        { style: "cellStyle", text: "1" },
        {
          style: "cellStyle",
          text: component.name,
        },
      ];
    });
  };

  const getEmptiesRelatedCouplings = (filteredCouplings) => {
    return filteredCouplings
      .filter((coup) => !coup[0]?.includes("EC7"))
      .map((coup, i) => {
        const matched = productsConfiguration.find(
          ({ code }) => code === coup[0]
        );

        return [
          [
            {
              style: "cellStyle",
              text: matched.fixed,
            },
            { style: "cellStyle", text: getConfigurationQuantity(coup[0]) },
            {
              style: "cellStyle",
              text: coup[0]?.includes("EC6")
                ? "M " + coup[0] + "*"
                : "M " + coup[0],
            },
          ],
          [
            {
              style: "cellStyle",
              text: matched.mobile,
            },
            { style: "cellStyle", text: getConfigurationQuantity(coup[0]) },
            {
              style: "cellStyle",
              text: coup[0]?.includes("EC6")
                ? "F " + coup[0] + "*"
                : "F " + coup[0],
            },
          ],
        ];
      });
  };

  const getEmptiesRelatedCap = (product) => {
    const code = product.name
      .split("MULTI")
      .join("")
      .split("COMPLETE")
      .join("")
      .split("FIX")
      .join("")
      .split("MOBILE")
      .join("")
      .split("EMPTY")
      .join("")
      .split("- CAP")
      .join("")
      .trim();

    const emptyCouple = products.filter(
      (prod) => prod.name.includes(code) && prod.name.includes("EMPTY")
    );

    const emptyCap = emptyCouple.filter((prod) => prod.cap);

    return emptyCap.map((component, i) => {
      return [
        {
          style: "cellStyle",
          text: component.cap?.split(" ")[0],
        },
        { style: "cellStyle", text: "1" },
        {
          style: "cellStyle",
          text: splitAndShift(component.cap),
        },
      ];
    });
  };

  const getEmptiesRelatedParkingStation = (product) => {
    const code = product.name
      .split("MULTI")
      .join("")
      .split("COMPLETE")
      .join("")
      .split("FIX")
      .join("")
      .split("MOBILE")
      .join("")
      .split("EMPTY")
      .join("")
      .split("- CAP")
      .join("")
      .trim();

    const emptyCouple = products.filter(
      (prod) => prod.name.includes(code) && prod.name.includes("EMPTY")
    );

    const emptyParkingStation = emptyCouple.filter(
      (prod) => prod.parking_station
    );

    return emptyParkingStation.map((component, i) => {
      return [
        {
          style: "cellStyle",
          text: component.parking_station?.split(" ")[0],
        },
        { style: "cellStyle", text: "1" },
        {
          style: "cellStyle",
          text: splitAndShift(component.parking_station),
        },
      ];
    });
  };

  const getEmptiesRelatedProduct = (product, type, couplings, cap) => {
    const relatedRows = products
      .filter(
        (prod) =>
          prod.picture === product.picture &&
          prod.name.includes("EMPTY") &&
          prod.name.includes(type !== "FIX" ? "FIX" : "MOBILE")
      )
      .map((component, i) => {
        return [
          { style: "cellStyle", text: component.code },
          { style: "cellStyle", text: "1" },
          { style: "cellStyle", text: component.name },
        ];
      });

    return relatedRows;
  };

  const getEmptyProductSection = (
    product,
    type,
    filteredCouplings,
    catalogue,
    circles
  ) => {
    if (catalogue) {
      return [
        { text: "SELECTED PRODUCT", style: "header" },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "*"],
            body: [
              [
                { text: "Code", style: "tableHeader" },
                { text: "Name", style: "tableHeader" },
                { text: "Description", style: "tableHeader" },
              ],
              [
                {
                  style: "cellStyle",
                  text: product.code,
                },
                { style: "cellStyle", text: product.name },
                {
                  style: "cellStyle",
                  text: product.description,
                },
              ],
            ],
          },
          layout: whiteTableLayout,
        },
        {
          text: `Max operating resistance is ${product.max_resistance}`,
          style: "tableFooter",
        },
        {
          text: "RELATED PRODUCTS",
          style: "subHeader",
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "*"],
            body: [
              [
                { text: "Code", style: "tableHeader" },
                { text: "Quantity", style: "tableHeader" },
                { text: "Description", style: "tableHeader" },
              ],
              ...getEmptiesRelatedProduct(product, type),
            ],
          },
          layout: blueTableLayout,
        },
      ];
    } else {
      return [
        { text: "SELECTED PRODUCT", style: "header" },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "*"],
            body: [
              [
                { text: "Code", style: "tableHeader" },
                { text: "Quantity", style: "tableHeader" },
                { text: "Description", style: "tableHeader" },
              ],
              ...getEmptyCouple(product),
            ],
          },
          layout: blueTableLayout,
        },
        {
          text: `Max operating resistance is ${
            getEmptyCouple(product)[0]?.[0]?.text
              ? products.find(
                  (p) => p.code === getEmptyCouple(product)[0][0].text
                )?.max_resistance || product.max_resistance
              : product.max_resistance
          }`,
          style: "tableFooter",
        },
        {
          text: "COMPONENTS NOT INCLUDED WITH THE PLATES (TO BE ORDERED SEPARATELY)",
          style: "subHeader",
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "*"],
            body: [
              [
                { text: "Code", style: "tableHeader" },
                { text: "Quantity", style: "tableHeader" },
                { text: "Description", style: "tableHeader" },
              ],
              ...getEmptiesRelatedCouplings(filteredCouplings).flat(),
              ...getEmptiesRelatedCap(product),
              ...getEmptiesRelatedParkingStation(product),
            ],
          },
          layout: blueTableLayout,
        },
        ...(!catalogue && circles?.find((value) => value?.type === "electric")
          ? [
              {
                text: `* Standard EC with ${
                  circles.find((value) => value?.type === "electric")?.setting
                    ?.poles?.value || 6
                } poles; other versions available upon request`,
                style: "tableFooter",
              },
            ]
          : []),
      ];
    }
  };

  return {
    info: {
      title: product.name,
      author: "Multiconfigurator Stucchi",
    },
    content: [
      ...getHeader(logoImage),
      ...getConfigurationSection(catalogue, circles),
      getImage(printPage, image),
      ...getProductsSection(
        product,
        type,
        filteredCouplings,
        catalogue,
        circles
      ),
      ...getWarning(),
    ],
    styles: {
      header: {
        fontSize: 13,
        bold: true,
        color: "#000",
        margin: [0, 16, 0, 10],
      },
      subHeader: {
        fontSize: 11,
        bold: true,
        color: "#000",
        margin: [0, 12, 0, 6],
      },
      tableExample: {
        margin: [0, 0, 0, 10],
      },
      tableHeader: {
        color: "#000",
        bold: false,
        fontSize: 9,
        alignment: "left",
      },
      tableFooter: {
        margin: [0, 3, 0, 10],
        fontSize: 9,
        italics: true,
        color: "#555555",
      },
      cellStyle: {
        fontSize: 9,
        alignment: "left",
      },
    },
  };
};

export default formattedPdf;
